import type {Elements, IContentItem} from '@kontent-ai/delivery-sdk'
import type {Block} from '@/services/kontent-ai/types'
import {RichTextRenderer} from '@/products/flexible-web-toolkit/components/rich-text-renderer'
import {Tabs as CTabs} from '@/products/flexible-web-toolkit/components/tabs'
import {Tab as CTab} from '@/products/flexible-web-toolkit/components/tabs/tab'
import {spacing} from '@/products/flexible-web-toolkit/styles'

type FullTabbedBlockTabContentItem = IContentItem<{
	heading: Elements.TextElement
	body: Elements.RichTextElement
	pinned: Elements.MultipleChoiceElement
	snippetSpacingSpacing: Elements.MultipleChoiceElement
}>

export type FullTabbedBlockContentItem = IContentItem<{
	tabs: Elements.LinkedItemsElement<FullTabbedBlockTabContentItem>
	snippetSpacingSpacing: Elements.MultipleChoiceElement
}>

export const FullTabbedBlockBlock: Block<FullTabbedBlockContentItem> = ({
	block,
	...context
}) => {
	const componentSpacing =
		spacing[
			// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- snippetSpacingSpacing can be null at runtime
			(block.elements.snippetSpacingSpacing?.[0]?.codename ??
				'none') as keyof typeof spacing
		]
	return (
		<div className={componentSpacing}>
			<CTabs aria-label="Footer tabs" name="fullTabs">
				{block.elements.tabs.map(
					({elements: {heading, body, pinned}, system: {id}}) => (
						<CTab
							data-kontent-item-id={id}
							key={id}
							pinned={pinned[0]?.codename === 'yes'}
							title={heading}
						>
							<RichTextRenderer
								className="flex-g break-words"
								data-kontent-element-codename="body"
								element={body}
								{...context}
							/>
						</CTab>
					)
				)}
			</CTabs>
		</div>
	)
}
